module.exports = __webpack_public_path__ + "img/service-2.1f0b63bf.svg";